import React from 'react';
import { useState } from 'react';
import { Menu, X, Settings, FileText, Shield, TrendingDown } from 'lucide-react';

const  Benifits=()=> {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8f9fa' }}>
    
      <main className="relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Purple dots */}
          <div 
            className="absolute w-3 h-3 rounded-full top-20 left-10"
            style={{ backgroundColor: '#8B5CF6' }}
          ></div>
          <div 
            className="absolute w-2 h-2 rounded-full top-40 right-20"
            style={{ backgroundColor: '#8B5CF6' }}
          ></div>
          <div 
            className="absolute w-4 h-4 rounded-full bottom-40 left-20"
            style={{ backgroundColor: '#8B5CF6' }}
          ></div>
          <div 
            className="absolute w-3 h-3 rounded-full bottom-60 right-10"
            style={{ backgroundColor: '#8B5CF6' }}
          ></div>
          <div 
            className="absolute w-2 h-2 rounded-full top-60 right-40"
            style={{ backgroundColor: '#8B5CF6' }}
          ></div>

          {/* Yellow decorative shapes */}
          <div className="absolute top-32 left-4">
            <div 
              className="w-8 h-8 transform rotate-45"
              style={{ backgroundColor: '#F59E0B' }}
            ></div>
          </div>
          <div className="absolute top-20 right-4">
            <div 
              className="w-0 h-0 border-l-4 border-r-4 border-b-8 border-transparent"
              style={{ borderBottomColor: '#F59E0B' }}
            ></div>
          </div>
          <div className="absolute bottom-32 right-8">
            <div 
              className="w-0 h-0 border-l-6 border-r-6 border-b-10 border-transparent"
              style={{ borderBottomColor: '#F59E0B' }}
            ></div>
          </div>
          <div className="absolute bottom-20 left-8">
            <div 
              className="w-0 h-0 border-l-8 border-r-8 border-t-12 border-transparent"
              style={{ borderTopColor: '#F59E0B' }}
            ></div>
          </div>

          {/* Orange stars */}
          <div className="absolute top-40 left-1/3">
            <div 
              className="w-1 h-1 rounded-full"
              style={{ backgroundColor: '#F97316' }}
            ></div>
          </div>
          <div className="absolute bottom-50 right-1/3">
            <div 
              className="w-1 h-1 rounded-full"
              style={{ backgroundColor: '#F97316' }}
            ></div>
          </div>
        </div>

        {/* Hero Section */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
          <div className="text-center">
            <h1 className="text-3xl sm:text-xl lg:text-3xl font-semibold text-gray-800 mb-8 text-black">
              Easier, faster and simpler way to procure.
            </h1>
            <p className="text-lg sm:text-md text-gray-600 max-w-3xl mx-auto mb-16 leading-relaxed  ">
              Prokraya, our robust, secure, scalable spend management software automates an organisation's current 
              procurement process to reduce costs, lower risks, and accelerate digital transformation. It has been 
              designed for new-age organizations that demand greater usability and accessibility.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-12 max-w-5xl mx-auto">
            {/* Automation */}
            <div className="text-center p-2">
              <div className="flex justify-center mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: '#FDF2F8' }}
                >
                  <Settings size={40} style={{ color: '#EC4899' }} />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">AUTOMATION</h3>
              <p className="text-gray-600 leading-relaxed text-center max-w-sm ml-10">
                Minimises human intervention and creates uniformity while increasing efficiency.
              </p>
            </div>

            {/* Transparency */}
            <div className="text-center p-2">
              <div className="flex justify-center mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: '#F0FDF4' }}
                >
                  <FileText size={40} style={{ color: '#10B981' }} />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">TRANSPARENCY</h3>
              <p className="text-gray-600 leading-relaxed text-center text-md max-w-md ml-10">
                Helps drive significant progress and establish trust between buyer and supplier.
              </p>
            </div>

            {/* Risk Mitigation */}
            <div className="text-center p-2">
              <div className="flex justify-center mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: '#F5F3FF' }}
                >
                  <Shield size={40} style={{ color: '#8B5CF6' }} />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">RISK MITIGATION</h3>
              <p className="text-gray-600 leading-relaxed text-center max-w-sm ml-10">
                Identification and elimination of issues by conducting timely audit and reviews.
              </p>
            </div>

            {/* Cost Reduction */}
            <div className="text-center p-2">
              <div className="flex justify-center mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: '#FFF7ED' }}
                >
                  <TrendingDown size={40} style={{ color: '#F97316' }} />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">COST REDUCTION</h3>
              <p className="text-gray-600 leading-relaxed  text-center max-w-sm ml-10">
                Focusing over most efficient and affordable ways to procure.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Benifits;